/**
 * BR 驳回理由展示。
 * · AI 短码/JSON 转义由后端 udf_GetAliyunRejectLabel /
 *   proc_ApprovalRequest_GetRejectReasonByApprovalId 负责（管理端 hydrate 写入）。
 * · 此处仅做供应商展示用的「手动输入」前缀清理；人工自由文本原样展示。
 * · 另剔除 udf 空壳「內容被駁回，原因如下:  -」（无有效 bullet 时）。
 */

/** 管理端 OTHER 选项标签（仅去掉标签本身，绝不能误伤真实驳回正文） */
const ADMIN_OTHER_LABEL_ALT = '選擇手動輸入原因|选择手动输入原因|Select to enter reason manually';
const ADMIN_OTHER_LABEL_ONLY_RE = new RegExp(`^(?:${ADMIN_OTHER_LABEL_ALT})$`, 'i');
/** 「選擇手動輸入原因：23」→「23」；无冒号的孤立标签整段丢弃 */
const ADMIN_OTHER_LABEL_PREFIX_RE = new RegExp(
  `^(?:${ADMIN_OTHER_LABEL_ALT})\\s*[:：]\\s*`,
  'i',
);
/**
 * udf_GetAliyunRejectLabel 在短码未落成可读句时，常吐出仅有标题+空 bullet 的壳：
 * 「內容被駁回，原因如下:  -」——对管理端/供应商均视为无理由。
 */
const HOLLOW_AI_REJECT_LABEL_RE = /^(?:內容被駁回|内容被驳回|Content\s+rejected)[^:：]*[:：]\s*-?\s*$/i;

/**
 * 供应商展示用：只剥管理端「手动输入」标签前缀，保留 {errorMessage} 正文。
 * 例：選擇手動輸入原因：证件不清晰 → 证件不清晰
 */
export function sanitizeBrRejectReasonForSupplier(rawReason) {
  const text = String(rawReason || '').trim();
  if (!text) {
    return '';
  }
  if (HOLLOW_AI_REJECT_LABEL_RE.test(text)) {
    return '';
  }
  return text
    .split(/\s*;\s*/)
    .map((part) => {
      const chunk = String(part || '').trim();
      if (!chunk) {
        return '';
      }
      if (ADMIN_OTHER_LABEL_ONLY_RE.test(chunk)) {
        return '';
      }
      if (HOLLOW_AI_REJECT_LABEL_RE.test(chunk)) {
        return '';
      }
      return chunk.replace(ADMIN_OTHER_LABEL_PREFIX_RE, '').trim();
    })
    .filter(Boolean)
    .join('; ');
}

export function resolveBrRejectReason(item) {
  return sanitizeBrRejectReasonForSupplier(
    item?.rejectReason
    || item?.RejectReason
    || item?.rejectTitle
    || item?.RejectTitle
    || '',
  );
}

/**
 * 展示文案：sanitize 后原样返回（不再做短码→i18n）。
 */
export function resolveBrRejectReasonText(item) {
  return resolveBrRejectReason(item);
}
